/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import debounce from 'lodash/debounce'
import differenceBy from 'lodash/differenceBy'

import { cx } from '@emotion/css'
import LoaderIcon from '@offerzen/zenicon/LoaderIcon'
import CloseIcon from '@offerzen/zenicon/CloseIcon'
import SearchIcon from '@offerzen/zenicon/SearchIcon'
import FormErrorMessage from '../FormErrorMessage'
import FormHelpText from '../FormHelpText'
import AccessibleIcon from '../AccessibleIcon'
import Tag from '../Tag'
import FormWarningMessage from '../FormWarningMessage'

import styles, { fieldTheme, itemTheme, iconColor } from './styles'

import { MultiSearchNoResults } from './MultiSearchNoResults'
import { MultiSearchOption } from './MultiSearchOption'

class MultiSearch extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    open: false,
    selectedIndex: -1,
    options: [],
  }

  triggerFetch = debounce(query => {
    if (query === '') {
      this.clearInput()
      return
    }

    if (this.props.onClear) this.props.onClear()
    this.props.onSearch(query)
  }, 150)

  componentDidUpdate(prevProps) {
    if (prevProps.fetching && !this.props.fetching) {
      const selectedOptions = this.props.input.value || this.props.value
      const options = differenceBy(this.props.results, selectedOptions, 'value')

      this.setState({ open: true, options, selectedIndex: -1 })
    }
  }

  handleNavigation = ev => {
    if (ev.keyCode === 38 || ev.keyCode === 40) {
      // If arrows up and down were pressed
      ev.preventDefault()

      // Pressing down in options +1, pressing up in options -1
      const selectedIndex = this.state.selectedIndex + (ev.keyCode - 39)
      if (selectedIndex >= 0 && selectedIndex < this.state.options.length) {
        this.setState({ selectedIndex })

        // If the body is scrollable, make sure the selected option is visible
        // Also, we're making sure that the reference exists to avoid null errors
        if (this.body && this.body.scrollHeight > this.body.offsetHeight) {
          // Get the reference of the new selected option
          const selectedOption = this.body.children[selectedIndex]
          // Calculate the visible area of the menu
          const visibleArea = this.body.scrollTop + this.body.offsetHeight

          if (selectedOption.offsetTop < this.body.scrollTop) {
            selectedOption.scrollIntoView()
          } else if (selectedOption.offsetTop + selectedOption.offsetHeight > visibleArea) {
            // eslint-disable-next-line operator-assignment
            this.body.scrollTop = this.body.scrollTop + selectedOption.offsetHeight
          }
        }
      }
    } else if (ev.keyCode === 27) {
      // If esc was pressed
      ev.preventDefault()

      this.setState({ open: false, selectedIndex: -1, options: [] })
    } else if (ev.keyCode === 13) {
      // If enter was pressed
      ev.preventDefault()

      const { selectedIndex } = this.state

      if (selectedIndex >= 0) {
        const item = this.state.options[selectedIndex]

        this.selectItem(item)
        this.setState({ open: false, selectedIndex: -1, options: [] })
      } else if (this.props.canSelectSearchTerm) {
        const value = this.props.input.value || this.props.value
        const labelObject = value.find(elem => !elem.value)

        if (labelObject) {
          this.selectItem({ ...labelObject, value: labelObject.label })
          this.setState({ open: false, selectedIndex: -1, options: [] })
        }
      }
    }

    if (this.props.onKeyDown) this.props.onKeyDown(ev)
  }

  handleChange = ev => {
    const value = this.props.input.value || this.props.value
    const handler = this.props.input.onChange || this.props.onChange

    if (handler) handler([...value.filter(elem => !!elem.value), { label: ev.target.value }])
    this.triggerFetch(ev.target.value)
  }

  handleBlur = () => {
    const handler = this.props.input.onBlur || this.props.onBlur
    if (handler) handler() // TODO fix
  }

  handleFocus = ev => {
    const handler = this.props.input.onFocus || this.props.onFocus
    if (handler) handler(ev)

    const value = this.props.input.value || this.props.value
    const labelObject = value.find(elem => !elem.value) || {}
    if (!labelObject.label) return

    this.setState({ selectedIndex: -1, options: [] })
  }

  clearInput = () => {
    const handler = this.props.input.onChange || this.props.onChange
    const value = this.props.input.value || this.props.value

    if (handler) handler(value.filter(elem => !!elem.value))
    if (this.props.onClear) this.props.onClear()

    this.setState({ open: false, selectedIndex: -1, options: [] })
  }

  selectItem = item => {
    const handler = this.props.input.onChange || this.props.onChange
    const value = this.props.input.value || this.props.value

    if (handler) handler([...value.filter(elem => !!elem.value), item])
    this.input.focus()
  }

  render() {
    const { open, selectedIndex, options } = this.state
    const {
      meta,
      input,
      className,
      theme,
      helpText,
      results,
      value,
      onSearch,
      onClear,
      fetching,
      canSelectSearchTerm,
      noResultsText,
      onRemove,
      ...props
    } = this.props
    const handler = input.onChange || props.onChange
    const valueArray = input.value || value
    const valueTags = valueArray.filter(elem => !!elem.value)
    const labelObject = valueArray.find(elem => !elem.value) || {}
    const label = labelObject.label || ''
    const errored = meta.touched && meta.error
    const { warning } = meta

    return (
      <div className={cx(styles.wrapper, className)}>
        {/* Render body first so the "input" appears on top */}
        {Boolean(open) && (
          <>
            <ul
              className={styles.body}
              // eslint-disable-next-line no-return-assign
              ref={el => (this.body = el)}>
              {!fetching && !warning && options.length < 1 && label.length > 0 ? (
                <MultiSearchNoResults
                  canSelectSearchTerm={canSelectSearchTerm}
                  handleClick={() => {
                    this.selectItem({ ...labelObject, value: labelObject.label })
                    this.setState({ open: false, selectedIndex: -1, options: [] })
                  }}
                  label={label}
                  addStyles={cx(styles.item, itemTheme(theme))}
                  emptyStyles={cx(styles.item, styles.emptyText)}
                  noResultsText={noResultsText}
                />
              ) : null}
              {options.length > 0
                ? options.map((item, idx) => (
                    <MultiSearchOption
                      key={item.value}
                      styles={cx(styles.item, itemTheme(theme, idx === selectedIndex))}
                      handleMouseOver={() => this.setState({ selectedIndex: idx })}
                      handleClick={() => {
                        this.selectItem(item)
                        this.setState({ open: false, selectedIndex: -1, options: [] })
                      }}>
                      {item.label}
                    </MultiSearchOption>
                  ))
                : null}
            </ul>
            <div data-testid="hack-overlay" className={styles.overlay} onClick={() => this.setState({ open: false, selectedIndex: -1 })} />
          </>
        )}
        <div
          className={cx(
            styles.field,
            fieldTheme(theme),
            open && styles.openField,
            errored && styles.fieldError,
            warning && styles.fieldWarning,
          )}>
          <input
            className={styles.input}
            type="text"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...input}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            value={label}
            autoComplete="off"
            // eslint-disable-next-line no-return-assign
            ref={el => (this.input = el)}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onKeyDown={this.handleNavigation}
          />

          <div
            aria-label="clear value"
            className={cx(styles.icon, fetching && styles.iconSpinning, label && styles.iconClear)}
            onClick={this.clearInput}>
            <AccessibleIcon
              // eslint-disable-next-line no-nested-ternary
              icon={fetching ? LoaderIcon : label ? CloseIcon : SearchIcon}
              size={20}
              color={iconColor(errored, warning)}
            />
          </div>
        </div>
        {Boolean(helpText && !errored && !warning) && <FormHelpText text={helpText} />}
        {Boolean(errored) && <FormErrorMessage text={meta.error} />}
        {Boolean(warning) && <FormWarningMessage text={meta.warning} />}
        {Boolean(valueTags.length) && (
          <ul className={styles.selectedItems}>
            {valueTags.map((item, index) => (
              <li className={styles.listItem} key={item.value}>
                <Tag
                  text={item.label}
                  theme={item.theme || theme}
                  onClear={() => {
                    const removedTag = valueTags.splice(index, 1)[0]

                    if (onRemove) onRemove(removedTag)
                    if (handler) handler(valueTags)
                  }}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  }
}

const themeOpts = ['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']

MultiSearch.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  value: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      theme: PropTypes.oneOf(themeOpts),
    }),
  ),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  onRemove: PropTypes.func,
  helpText: PropTypes.string,
  theme: PropTypes.oneOf(themeOpts),
  className: PropTypes.string,
  fetching: PropTypes.bool,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  canSelectSearchTerm: PropTypes.bool,
  noResultsText: PropTypes.string,
}

MultiSearch.defaultProps = {
  meta: {},
  input: {},
  value: [],
  results: [],
  fetching: false,
  theme: 'primary',
  canSelectSearchTerm: false,
  noResultsText: 'No results found',
}

export default MultiSearch
